
export default {
  name: "PdvDesktopAuthLayout",
};
